import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3000/consumer_choice";
};

// Bookmark Restaurant
export const loadBookmarkRestaurantList = params => {
  const url = `${baseURL()}/bookmark_restaurant_list`;
  return axios.post(url, params);
};

export const substituteBookmarkRestaurant = params => {
  const url = `${baseURL()}/bookmark_restaurant`;
  return axios.post(url, params);
};

// Don't Show Restaurant
export const loadDislikeRestaurantList = params => {
  const url = `${baseURL()}/dislike_restaurant_list`;
  return axios.post(url, params);
};

export const substituteDislikeRestaurant = params => {
  const url = `${baseURL()}/dislike_restaurant`;
  return axios.post(url, params);
};

// View History Restaurant

export const loadViewHistoryRestaurantList = params => {
  const url = `${baseURL()}/viewed_history_list`;
  return axios.post(url, params);
};

export const insertViewHistoryRestaurant = params => {
  const url = `${baseURL()}/viewed_history`;
  return axios.post(url, params);
};

export const deleteViewHistoryRestaurant = params => {
  const url = `${baseURL()}/remove_viewed_history`;
  return axios.post(url, params);
};

export const deleteViewHistoryRestaurantList = () => {
  const url = `${baseURL()}/remove_all_viewed_history`;
  return axios.post(url);
};

// Remove Multiple
export const deleteMultipleBookmarkOrDislikeRestaurant = params => {
  const url = `${baseURL()}/remove_multi`;
  return axios.post(url, params);
};

// Remove All
export const deleteBookmarkOrDislikeRestaurantList = params => {
  const url = `${baseURL()}/remove_all`;
  return axios.post(url, params);
};
